'use strict';

import { addEvent } from './addEvent/addEvent';
import { smoothScrollbarInit } from './smoothScrollbar/smoothScrollbar';
import { pageScrolled } from './pageScrolled/pageScrolled';
import { outlineInit } from './accessibility/accessibility';
import { addVideoToPage } from './addVideoToPage/addVideoToPage';
import { mobileMenu } from './mobileMenu/mobileMenu';
import { lazyLoadImage } from './lazyLoading/lazyLoading';
import { showMoreInfo } from './showMoreInfo/showMoreInfo';
import { ajaxFormClass } from './form/form';
import { cookiesClass } from './cookies/cookies';
import { fslightboxInit } from './fslightbox/fslightbox';
import { addToBasket } from './addToBasket/addToBasket';

document.addEventListener('DOMContentLoaded', () => {
  if (
    !document.body.classList.contains('mobile') &&
    !document.body.classList.contains('macos')
  )
    window.smoothScroll = smoothScrollbarInit({ damping: 0.1 });
  outlineInit();
  pageScrolled();
  fslightboxInit();
  addToBasketInit();

  window.mobileMenu = new mobileMenu();
  forms();
  new cookiesClass();
});

addEvent(window, 'load', () => {
  lazyLoadImage(
    document.querySelectorAll('[data-images]'),
    window.smoothScroll ? window.smoothScroll.containerEl : null
  );
  addVideoToPage();
  showMoreInfoInit();
});

addEvent(window, 'resize', () => {});

addEvent(window, 'scroll', () => {});

function showMoreInfoInit() {
  const elements = document.getElementsByTagName('body');
  Array.from(elements).forEach(elm => {
    new showMoreInfo({
      mainContainer: elm,
    });
  });
}

function forms() {
  let ajaxForms = document.getElementsByClassName('ajax-form');

  Array.from(ajaxForms).forEach(form => {
    new ajaxFormClass(form);
  });
}

function addToBasketInit() {
  new addToBasket();
  // pobiera oba typy formularzy naraz
  // const forms = document.querySelectorAll(
  //   '.do-koszyka-action-form, .do-koszyka-form'
  // );

  // forms.forEach(form => {
  //   if (!(form instanceof HTMLFormElement)) return;
  //   try {
  //     new addToBasket(form);
  //   } catch (err) {
  //     console.error(
  //       'Błąd inicjalizacji addToBasket dla formularza:',
  //       form,
  //       err
  //     );
  //   }
  // });
}
